// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4e9a98c4","977":"aa27ed20"}[chunkId] + ".chunk.js";
};